import React from "react";

import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { setShop } from "../../features/ShopSlice";
import TopBtnShop from "../../components/layout/TopBtnShop";
import CustomSwitch from "../../components/button/CustomSwitch";
import { DeleteEmployee, SearchEmployeeList } from "../../services/Shop";
import ownerLabel from '../../assets/images/owner-label.png'
import employeeLabel from '../../assets/images/employee-label.png'
import haierBtn from '../../assets/images/haier-store-btn.png'
import account from '../../assets/images/account.png'
import useWindowDimensions from "../../functions/getScreen";
import arrowBg from '../../assets/images/arrow-bg.png'
import { Dialog } from "@mui/material";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import { useLiff } from "react-liff";


export default function EmployeeList() {

    const { width } = useWindowDimensions();
    const dispatch = useDispatch();
    const [employeeList, setEmployeeList] = React.useState([]);
    const store = useSelector((state) => state.shop)
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
    const [employeeId, setEmployeeId] = React.useState(null);

    React.useEffect(() => {
        getSearchEmployeeList();
    }, []);

    async function getSearchEmployeeList() {
        return await SearchEmployeeList({ data: { shopId: store['shopId'], limit: 100, offset: 0 } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setEmployeeList(response.data.body.employee)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function postDeleteEmployee(employeeId) {
        return await DeleteEmployee({ data: { ownerId: store['ownerId'], employeeId: employeeId } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setEmployeeId(null)
                    setOpenCancelPopup(false)
                    getSearchEmployeeList();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setShop(tmpObj));
    }


    return (
        <div id="shop-page">
            <TopLogo />
            <TopBanner type="shopInfo" />
            <Dialog open={openCancelPopup} fullWidth={true} maxWidth="xl">
                <div className="py-[24px] px-[23px] rounded-[4px]">
                    <p className="text-[24px] font-bold text-center text-blue">ลบพนักงาน</p>
                    <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">คุณต้องการลบพนักงานคนนี้ใช่หรือไม่</p>
                    {/* <p className="text-gray text-[18px] text-center whitespace-pre-line leading-[120%]">หากมั่นใจแล้ว กรุณากด ยืนยัน เพื่อดำเนินการต่อ </p> */}

                    <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">

                        <SecondaryButton
                            variant="outlined"
                            className="w-full"
                            onClick={() => setOpenCancelPopup(false)}
                        >
                            ยกเลิก
                        </SecondaryButton>
                        <PrimaryButton
                            onClick={() => {
                                postDeleteEmployee(employeeId)
                            }}
                            variant="outlined"
                            className="w-full"
                        >
                            ยืนยัน
                        </PrimaryButton>

                    </div>

                </div >
            </Dialog >
            {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
            <div id="shop" style={{
                // backgroundImage: `url(${background})`,
                minHeight: "80px",
            }}
                className="bg-white px-[20px] mt-[-40px] pb-[10px]">
                <TopBtnShop type="employee" isOwner={store['isOwner']} />
                <div className="ml-[20px] mt-[-10px]">
                    <div className="flex gap-[10px] justify-start">
                        <div className="primary-color title-size">ข้อมูลพนักงาน </div>
                        <div style={{ marginTop: "6px" }}>
                            <p className="sub-title-size">Employee Information</p>
                            <div className="blue-line" ></div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="bg-lightBlue2" style={{
                height: "fit-content",
                minHeight: "500px",
                padding: "20px 40px",
            }}>

                <div>
                    <InfiniteScroll>
                        {Array.isArray(employeeList) && employeeList.length > 0 && employeeList.map((item, index) => (
                            <div key={index} style={{
                                height: 'fit-content',
                                background: 'white',
                                borderRadius: '6px',
                                // height: `${width / 3}px`,
                                marginBottom: '15px',
                                // backgroundImage: `url(${background})`,
                                // backgroundSize: 'contain',
                                // backgroundRepeat: 'no-repeat',
                                display: 'flex',
                                gap: '5px'
                            }}>
                                <div className="w-[40%]">
                                    <div className="h-full relative">
                                        {item.picture ?
                                            <img style={{
                                                width: "65%",
                                                position: "absolute",
                                                top: "45%",
                                                left: "50%",
                                                transform: "translate(-50%,-50%)",
                                            }} className="rounded-full" src={item.picture} alt="" />
                                            :
                                            <img style={{
                                                width: "65%",
                                                position: "absolute",
                                                top: "45%",
                                                left: "50%",
                                                transform: "translate(-50%,-50%)",
                                            }} src={account} alt="" />
                                        }
                                        {item.isOwner ?
                                            <img style={{
                                                width: "65%",
                                                position: "absolute",
                                                top: "10%",
                                                left: "0%",
                                            }} src={ownerLabel} alt="" /> :
                                            <img style={{
                                                width: "65%",
                                                position: "absolute",
                                                top: "10%",
                                                left: "0%",
                                            }} src={employeeLabel} alt="" />}


                                    </div>
                                </div>
                                <div className="w-[60%] relative">
                                    {(store['isOwner'] && !item.isOwner) &&
                                        <div style={{ float: 'right' }}>
                                            <CustomSwitch
                                                defaultChecked
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                checked={item.status === 'Active'}
                                                handleFunction={() => {
                                                    setEmployeeId(item.id)
                                                    setOpenCancelPopup(true)
                                                }}
                                            />
                                        </div>
                                    }
                                    {store['isOwner'] && !item.isOwner}
                                    <div style={{ wordWrap: 'break-word' }} className='mr-[8px]'>
                                        <p className="text-[14px] mt-[10px]" style={{ color: 'rgba(109, 110, 113, 1)', }}>ชื่อ-นามสกุล</p>
                                        <p className="text-[16px] leading-[10px]">{item.firstName} {item.lastName}</p>
                                        <p className="text-[14px]" style={{ color: 'rgba(109, 110, 113, 1)', }}>อีเมล</p>
                                        <p className="text-[16px] leading-[10px]">{item.email ? item.email : '-'}</p>
                                        <p className="text-[14px]" style={{ color: 'rgba(109, 110, 113, 1)', }}>เบอร์โทรศัพท์</p>
                                        <p className="text-[16px] leading-[10px]">{item.mobileNumber ? item.mobileNumber : '-'}</p>
                                    </div>
                                    <img className="mr-[8px] ml-[auto] mt-[-15px] mb-[8px]" style={{ width: "50%" }} src={haierBtn} alt="" />
                                    <img style={{
                                        position: "absolute",
                                        bottom: "0",
                                        right: "0",
                                        height: "100%"
                                    }} src={arrowBg} alt="" />

                                </div>


                            </div>

                        ))}
                    </InfiniteScroll>



                </div>


            </div >

        </div >
    )
}